import {
    createBrowserRouter,
    RouterProvider,
}                           from "react-router-dom";
import * as Views           from '../views';

const router = createBrowserRouter([
    {
        path    :   '/',
        element :   <Views.QueryForm />
                    
    },
    {
        path    :   '/invoice-details',
        element :   <Views.Invoice />
    },
]);

export {
    RouterProvider,
    router
}